module.exports = __webpack_public_path__ + "static/media/logo-cgl.df91f7a9.svg";